
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Style from "./Avatar.module.scss";
import BoysIcon from "../../../assets/svg/BoysIcon";
import GirlIcon from "../../../assets/svg/Girlicon";
import PerfectButtonIconLeft from "../../../assets/svg/PerfectButtonIconLeft";
import PerfectButtonIconRight from "../../../assets/svg/PerfectButtonIconRight";
import QuizWallicon from "../../../assets/svg/QuizWallicon";
import axios from "../../../config/authAxios";

export default function Avatar() {
	const [avatarValue, setAvatarValue] = useState(1)
	const navigate = useNavigate();

	const handleClick = async () => {
		try {
			if(avatarValue != 1 && avatarValue !=2){
				return
			}
			const response = await axios.put('/users/api/update/avtar', { avtar: avatarValue })
			// navigate('/RewardHome')
			navigate('/home-challenge')
		} catch (error) {
			console.error("Error updating avatar:", error);
		}
	}

	return (
		<>
			<div className={Style.avatar_container}>
				<div className={Style.avatar_box1}><QuizWallicon width={162} height={36} /></div>
				<div className={Style.avatar_bottm_box}>
					<div className={Style.avatar_box4}><p className={Style.login_text1}>Choose Your</p><p className={Style.login_text1}>Avatar</p></div>
					<div className={Style.avatar_box2}>
						<div className={Style.avatar_cover} onClick={() => setAvatarValue(1)}>{avatarValue == 1 && <div className={Style.avatar_tick}><img src={"https://d1qj6ph0z4cul6.cloudfront.net/live/pr_f_avatar-tick_1761338897543.png"} className={Style.tick_image} alt="tick-image" /></div>}<BoysIcon width={139} height={149} isActive={avatarValue == 1} /></div>
						<div className={Style.avatar_cover} onClick={() => setAvatarValue(2)}>{avatarValue == 2 && <div className={Style.avatar_tick}><img src={"https://d1qj6ph0z4cul6.cloudfront.net/live/pr_f_avatar-tick_1761338897543.png"} className={Style.tick_image} alt="tick-image" /></div>}<GirlIcon width={139} height={149} isActive={avatarValue == 2}/></div>
					</div>
					<div className={Style.avatar_box3} onClick={handleClick}>
						<PerfectButtonIconRight /><p className={Style.avatar_box_button} >Perfect</p><PerfectButtonIconLeft />
					</div>
				</div>

			</div>
		</>
	);
}
